import React from 'react';
import { Outlet } from 'react-router';
import Lottie from 'lottie-react';
import { useOfflineNetworkToast } from 'hooks/common';
import { LeavesAnimation } from 'assets/animations';
import styles from './InvitationLayout.module.css';

const InvitationLayout = (): JSX.Element => {
  useOfflineNetworkToast();

  return (
    <>
      <div className={styles.invitation}>
        <div className={styles.container}>
          <Outlet />
        </div>
      </div>
      <Lottie
        animationData={LeavesAnimation}
        className={styles.animation}
        rendererSettings={{
          viewBoxOnly: true,
          preserveAspectRatio: 'none',
        }}
      />
    </>
  );
};

export default InvitationLayout;
